export default __webpack_public_path__ + "static/media/toitu.424f0e4c.png";